<template>
<div>
    <div :test-id="keyname" class="update-card border border-gray-200 p-6 my-4 my-rounded bg-white">
        <div v-if="!isOpen" class="flex items-center justify-between">
            <div>
                <div class="font-light text-xs">{{label}}</div>
                <div class="card-value font-bold text-lg">{{user[keyname] || 'Aucun'}}</div>
            </div>
            <button @click="isOpen = true" class="btn-open-card bg-gray-200 border-gray-200 hover:bg-gray-300 text-gray-700 duration-200 px-3 py-2 text-sm font-light rounded"> {{$t('parametres.carte-modification.modifier')}} </button>
        </div>
        <div v-if="isOpen">
            <sav-input :type="inputType" :label="label" v-model="inputData" />
            <div class="mt-2">
                <button @click="closeCard" class="bg-gray-200 border-gray-200 hover:bg-gray-300 text-gray-700 duration-200 px-3 py-2 text-sm font-light rounded"> {{$t('parametres.carte-modification.annuler')}} </button>
                <button @click="update" class="btn-update bg-green-300 border-green-300 hover:bg-green-400 duration-200 px-3 py-2 text-sm font-light rounded"> {{$t('parametres.carte-modification.modifier')}} </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'
export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        keyname: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        inputType: {
            type: String,
            default: "texte"
        }
    },
    data() {
        return {
            isOpen: false,
            inputData: null
        }
    },
    methods: {
        closeCard() {
            this.isOpen = false
            this.inputData = this.user[this.keyname]
        },
        async update() {
            if (!this.user)
                return
            let objData = {
                prenom: this.user.prenom,
                nom: this.user.nom,
                mail: this.user.mail,
                tel: this.user.tel,
                id_conso: this.user.id
            }

            objData[this.keyname] = this.inputData

            // Check required fields
            let requiredFields = ['prenom', 'nom', 'mail', 'id_conso']
            let errorField = 0
            requiredFields.forEach((field) => {
                if (!objData[field]) {
                    errorField = 1
                    this.$toast.error('Champ incomplet')
                }
            })

            // Test email format
            const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!regexEmail.test(objData.mail)) {
                this.$toast.error('Adresse email incorrecte')
                errorField = 1
            }

            // Test nom & prenom format
            let prenomIsCorrect = /^[a-zA-ZÀ-ÿ\-]+$/.test(objData.prenom);
            if (!prenomIsCorrect) {
                this.$toast.error(this.$tt('Prénom incorrect'))
                errorField = 1
            }
            let nomIsCorrect = /^[a-zA-ZÀ-ÿ\-]+$/.test(objData.nom);
            if (!nomIsCorrect) {
                this.$toast.error(this.$tt('Nom incorrect'))
                errorField = 1
            }

            // Send request
            if (errorField == 0) {
                await apiService.post('setconso', objData)
                this.isOpen = false
                eventHub.$emit('refresh-user')
            }
        }
    },
    mounted() {
        this.inputData = this.user[this.keyname]
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/components/UpdateCard.vue